// Copyright (c) 2026 Solartek LLC. All rights reserved.

import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/utils';

/** The owner of FlowZa Time and the year it was first published, as LICENSE states them. */
export const COPYRIGHT_HOLDER = 'Solartek LLC';
export const COPYRIGHT_YEAR = 2026;

/**
 * "© 2026 Solartek LLC. All rights reserved." at the foot of every screen: the app shell, the /adm portal and the
 * signed-out frame. The legal name and year read the same in every language; <bdi> keeps them in order inside Arabic.
 */
export function CopyrightNotice({ className }: { className?: string }) {
  const { t } = useTranslation();
  return <p className={cn('text-xs', className)}><bdi>© {COPYRIGHT_YEAR} {COPYRIGHT_HOLDER}.</bdi> {t('app.allRightsReserved')}</p>;
}
